import React, { useEffect, useState } from 'react';
import { DatePicker } from 'antd';
import { Api_Endpoints } from '../../Api/apiEndpoint';
import { makeApiCall } from '../../Api/makeApiCall';
import { showErrorToast } from '../../utils/toastService';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { FaSync } from "react-icons/fa";
import CountUp from 'react-countup';
import {
  BarChart, Bar, LineChart, Line, XAxis, YAxis, CartesianGrid,
  Tooltip, ResponsiveContainer, PieChart, Pie, Cell,Legend
} from 'recharts';
import './DashboardPage.css';  // Import the CSS file


const { RangePicker } = DatePicker;
const Dashboard = () => {
  const currentYear = new Date().getFullYear();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [top5Vendors, setTop5Vendors] = useState([]);
  const [top5VendorFiltered, setTop5VendorFiltered] = useState([]);
  const [top5VendorAppliedFilter, setTop5VendorAppliedFilter] = useState(null);
  const [monthlyData, setMonthlyData] = useState([]);
  const [dashboardCounts, setDashboardCounts] = useState('');
  const [appliedMonthYear, setAppliedMonthYear] = useState(currentYear);
  const [loading, setLoading] = useState(false);
  const [dateRange, setDateRange] = useState([]);
  const [loadingMonth, setLoadingMonth] = useState(false);

  const COLORS = ['#4CAF50', '#f55734', '#F89880', '#ffbf00'];

  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);

  const applyYear = async (year) => {
    setLoadingMonth(true);
    setAppliedMonthYear(year);
    try {
      const response = await makeApiCall(Api_Endpoints.dashboard_count, 'GET', { year });
      if (response?.status === 200) {
        setMonthlyData(response?.data?.dashboardDetails?.monthlyData);
      } else {
        showErrorToast(response?.message);
      }
    } catch (error) {
      showErrorToast('Failed to fetch year data');
    }
    setLoadingMonth(false);
  };

  const applyFilters = async (propo) => {
    if (propo !== null) {
      const top5ClaimData = await makeApiCall(Api_Endpoints.top5PartsforClaimAPi, 'GET', propo);
      if (top5ClaimData?.status === 200) {
        setTop5VendorFiltered(top5ClaimData?.data);
      }
      setTop5VendorAppliedFilter(propo);
    } else {
      setTop5VendorFiltered([]);
    }
    handleCloseModal();
  };


  const fetchData = async () => {
    setLoading(true);
    try {
      const [response, top5ClaimData] = await Promise.all([
        makeApiCall(Api_Endpoints.DASHBOARD_COUNT, 'GET'),
        makeApiCall(Api_Endpoints.top5PartsforClaimAPi, 'GET')
      ]);
      console.log('DASHBOARD_COUNT Response:', response);

      if (response?.status) {
        setDashboardCounts(response?.result);
        console.log(response.result)
        setMonthlyData(response.result);
      }
    } catch (error) {
      showErrorToast('Failed to fetch dashboard data');
    }
    setLoading(false);
  };

  const handleDateRangeChange = (dates, dateStrings) => {
    setDateRange(dates); // Update state with the selected date range
    if (dates && dates.length === 2) {
      fetchData(dateStrings[0], dateStrings[1]); // Fetch data for the selected date range
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const statsCards = [
    {
      title: 'Total Vendors',
      value: dashboardCounts?.total_vendor,
      color: '#4CAF50',
      bgColor: '#E8F5E9'
    },
    {
      title: 'Approved Vendors',
      value: dashboardCounts?.total_approved_vendor,
      color: '#2196F3',
      bgColor: '#E3F2FD'
    },
    {
      title: 'Pending Vendors',
      value: dashboardCounts?.total_pending_vendor,
      color: '#FFC107',
      bgColor: '#FFF8E1'
    },
    {
      title: 'Refer-Back Vendors',
      value: dashboardCounts?.total_referred_vendor,
      color: '#F44336',
      bgColor: '#FFEBEE'
    }
  ];

  const pieData = [
    { name: 'Approved', value: dashboardCounts?.total_approved_invoice || 0 },
    { name: 'Paid', value: dashboardCounts?.total_paid_invoice || 0 },
    { name: 'ReferBack', value: dashboardCounts?.total_referred_invoice || 0 },
    { name: 'Pending', value: dashboardCounts?.total_pending_invoice || 0 },
    { name: 'unpaid', value: dashboardCounts?.total_un_paid_invoice || 0 }
  ];

  const barChartData = [
    { name: 'Total', value:  dashboardCounts?.total_vendor || 0 },
    { name: 'ReferBack', value: dashboardCounts?.total_referred_vendor|| 0 },
    { name: 'Pending', value: dashboardCounts?.total_pending_vendor || 0 },
    { name: 'Approved', value: dashboardCounts?.total_approved_vendor || 0 }
  ];

  const data = [
    {
      month: "January",
      Total: dashboardCounts?.total_vendor || 0,
      ReferBack: dashboardCounts?.total_referred_vendor || 0,
      Approved: dashboardCounts?.total_approved_vendor || 0,
      Pending: dashboardCounts?.total_pending_vendor || 0,
    },
    {
      month: "February",
      Total: dashboardCounts?.total_vendor || 0,
      ReferBack: dashboardCounts?.total_referred_vendor || 0,
      Approved: dashboardCounts?.total_approved_vendor || 0,
      Pending: dashboardCounts?.total_pending_vendor || 0,
    },
    {
      month: "March",
      Total: dashboardCounts?.total_vendor || 0,
      ReferBack: dashboardCounts?.total_referred_vendor || 0,
      Approved: dashboardCounts?.total_approved_vendor || 0,
      Pending: dashboardCounts?.total_pending_vendor || 0,
    },
    {
      month: "April",
      Total: dashboardCounts?.total_vendor || 0,
      ReferBack: dashboardCounts?.total_referred_vendor || 0,
      Approved: dashboardCounts?.total_approved_vendor || 0,
      Pending: dashboardCounts?.total_pending_vendor || 0,
    },
    {
      month: "May",
      Total: dashboardCounts?.total_vendor || 0,
      ReferBack: dashboardCounts?.total_referred_vendor || 0,
      Approved: dashboardCounts?.total_approved_vendor || 0,
      Pending: dashboardCounts?.total_pending_vendor || 0,
    },
    {
      month: "June",
      Total: dashboardCounts?.total_vendor || 0,
      ReferBack: dashboardCounts?.total_referred_vendor || 0,
      Approved: dashboardCounts?.total_approved_vendor || 0,
      Pending: dashboardCounts?.total_pending_vendor || 0,
    },
    {
      month: "July",
      Total: dashboardCounts?.total_vendor || 0,
      ReferBack: dashboardCounts?.total_referred_vendor || 0,
      Approved: dashboardCounts?.total_approved_vendor || 0,
      Pending: dashboardCounts?.total_pending_vendor || 0,
    },
    {
      month: "August",
      Total: dashboardCounts?.total_vendor || 0,
      ReferBack: dashboardCounts?.total_referred_vendor || 0,
      Approved: dashboardCounts?.total_approved_vendor || 0,
      Pending: dashboardCounts?.total_pending_vendor || 0,
    },
    {
      month: "September",
      Total: dashboardCounts?.total_vendor || 0,
      ReferBack: dashboardCounts?.total_referred_vendor || 0,
      Approved: dashboardCounts?.total_approved_vendor || 0,
      Pending: dashboardCounts?.total_pending_vendor || 0,
    },
    {
      month: "October",
      Total: dashboardCounts?.total_vendor || 0,
      ReferBack: dashboardCounts?.total_referred_vendor || 0,
      Approved: dashboardCounts?.total_approved_vendor || 0,
      Pending: dashboardCounts?.total_pending_vendor || 0,
    },
    {
      month: "November",
      Total: dashboardCounts?.total_vendor || 0,
      ReferBack: dashboardCounts?.total_referred_vendor || 0,
      Approved: dashboardCounts?.total_approved_vendor || 0,
      Pending: dashboardCounts?.total_pending_vendor || 0,
    },
    {
      month: "December",
      Total: dashboardCounts?.total_vendor || 0,
      ReferBack: dashboardCounts?.total_referred_vendor || 0,
      Approved: dashboardCounts?.total_approved_vendor || 0,
      Pending: dashboardCounts?.total_pending_vendor || 0,
    },
  ];
  
  const transformedData = {
    invoiceData: [
      { name: 'Total Invoice', value: dashboardCounts?.total_invoice || 0 },
      { name: 'Pending Invoice', value: dashboardCounts?.total_pending_invoice || 0 },
      { name: 'Approved Invoice', value: dashboardCounts?.total_approved_invoice || 0 },
      { name: 'Paid Invoice', value: dashboardCounts?.total_paid_invoice || 0 },
      { name: 'Unpaid Invoice', value: dashboardCounts?.total_un_paid_invoice || 0 }
    ],
    vendorData: [
      { name: 'Total Vendor', value: dashboardCounts?.total_vendor || 0 },
      { name: 'Pending Vendor', value: dashboardCounts?.total_pending_vendor || 0 },
      { name: 'Approved Vendor', value: dashboardCounts?.total_approved_vendor || 0 },
      { name: 'Refer-Back Vendor', value: dashboardCounts?.total_referred_vendor || 0 }
    ]
  };

  const combinedData = transformedData.invoiceData.map((invoiceItem, index) => {
    return {
      name: invoiceItem.name,
      invoiceValue: invoiceItem.value,
      vendorValue: transformedData.vendorData[index]?.value || 0
    };
  });

  return (
    <div className="dashboard-container">
      <div className="dashboard-header">
        <h1 className="dashboard-title">Vendor Management Dashboard</h1>
        <button onClick={fetchData} className="refreshButton">
          <FaSync />
        </button>
      </div>

      <div className="statsGrid">
        {statsCards.map((stat, index) => (
          <div key={index} className="statCard" style={{
            backgroundColor: stat.bgColor,
            borderLeft: `4px solid ${stat.color}`
          }}>
            <h3>{stat.title}</h3>
            <p className="statValue">
              {loading ? (
                <Skeleton width={60} />
              ) : (
                <CountUp start={0} end={stat.value || 0} duration={2.5} separator="," />
              )}
            </p>
          </div>
        ))}
      </div>

      <div className="chartsGrid">
        <div className="chartCard">
          <div className="chartTitleWithFilter">
            <h2 className="chartTitle">Vendor Count</h2>
            <RangePicker
              onChange={handleDateRangeChange}
              format="YYYY-MM-DD"
              style={{ marginLeft: '20px' }}
            />
          </div>
          {(loading || loadingMonth) ? (
            <Skeleton height={300} />
          ) : (
            <ResponsiveContainer width="100%" height={300}>
                    <BarChart
        data={data}
        margin={{
          top: 20,
          right: 30,
          left: 20,
          bottom: 5,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="month" />
        <YAxis />
        <Tooltip />
        <Legend />
        {/* Bars for each data point */}
        <Bar dataKey="ReferBack" fill="#8884d8" name="ReferBack" />
        <Bar dataKey="Approved" fill="#82ca9d" name="Approved" />
        <Bar dataKey="Pending" fill="#ffc658" name="Pending" />
        <Bar dataKey="Total"  fill='#ccc' name="Total" />
      </BarChart>

            </ResponsiveContainer>
          )}
        </div>

      </div>
    </div>
  );
};

export default Dashboard;
